// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var JsxRuntime = require("react/jsx-runtime");
var StarRating$ReactHooksTemplate = require("./StarRating.res.js");
var QuestionText$ReactHooksTemplate = require("./QuestionText.res.js");
var SurveyLanguage$ReactHooksTemplate = require("./surveyLanguage.res.js");
var StarRatingScale$ReactHooksTemplate = require("./StarRatingScale.res.js");
var MandatoryMessage$ReactHooksTemplate = require("./MandatoryMessage.res.js");
var OrganizationProfile$ReactHooksTemplate = require("../settings/organizationProfile.res.js");
var StarRatingDefaultForm$ReactHooksTemplate = require("./StarRatingDefaultForm.res.js");

function StarRatingForm(props) {
  var substitutionVariables = props.substitutionVariables;
  var onChange = props.onChange;
  var language = props.language;
  var mandatory = props.mandatory;
  var starRating = props.starRating;
  var match = OrganizationProfile$ReactHooksTemplate.name(props.client);
  switch (match) {
    case "bhima" :
    case "ncell" :
    case "nykaa" :
        break;
    default:
      return JsxRuntime.jsx(StarRatingDefaultForm$ReactHooksTemplate.make, {
                  starRating: starRating,
                  mandatory: mandatory,
                  language: language,
                  onChange: onChange,
                  borderCss: props.borderCss,
                  substitutionVariables: substitutionVariables
                });
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(QuestionText$ReactHooksTemplate.make, {
                      text: StarRating$ReactHooksTemplate.getTextTranslation(starRating, SurveyLanguage$ReactHooksTemplate.name(language)),
                      description: StarRating$ReactHooksTemplate.getDescriptionTranslation(starRating, SurveyLanguage$ReactHooksTemplate.name(language)),
                      mandatory: mandatory,
                      surveyTheme: props.surveyTheme,
                      substitutionVariables: substitutionVariables
                    }),
                JsxRuntime.jsx(StarRatingScale$ReactHooksTemplate.make, {
                      starRating: starRating,
                      onChange: onChange,
                      layout: "Survey"
                    }),
                mandatory ? JsxRuntime.jsx(MandatoryMessage$ReactHooksTemplate.make, {
                        language: language
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
              ],
              className: "w-full flex flex-col py-8 px-16 small:px-6"
            });
}

var make = StarRatingForm;

exports.make = make;
/* react/jsx-runtime Not a pure module */
